import { createContext, useContext } from 'react'
import type { User } from '@/common/types'

export const UserContext = createContext<{ user: User | null } | null>(null)

export const useUser = () => {
    const ctx = useContext(UserContext)
    if (!ctx) throw new Error('useUser must be called within UserProvider')
    return ctx.user
}
